import { Injectable } from '@angular/core';
import { AccountService, AgencyInquiryService, AgencyService, EmployeeService, KioskService, PasswordResetService, VersionService } from 'src/openapi-gen/services';

@Injectable({
    providedIn: 'root'
})
export class AppConfig {
    private _config: { [key: string]: any };

    // Do not redirect to an error page for these relative api urls
    // Any errors that occur from these endpoints must be handled in the associated request scope
    // Dynamic URL example: "controller/endpoint/:id"
    DontGoToErrorPage_RelativeUrls: string[] = [
        VersionService.ApiVersionGetPath,
        AccountService.ApiAccountLoginPostPath,
        AccountService.ApiAccountLogoutPostPath,
        AccountService.ApiAccountVerifyAccountPostPath,
        AccountService.ApiAccountInitRefreshPostPath,
        PasswordResetService.ApiPasswordresetSendResetEmailPostPath,
        PasswordResetService.ApiPasswordresetVerifyPasswordResetLinkPostPath,
        PasswordResetService.ApiPasswordresetResetPostPath,
        EmployeeService.ApiEmployeeRegisterPostPath,
        EmployeeService.ApiEmployeeCheckUsernameGetPath,
        EmployeeService.ApiEmployeeCheckEmailGetPath,
        EmployeeService.ApiEmployeeCheckBarcodeGetPath,
        EmployeeService.ApiEmployeeCheckPinGetPath,
        KioskService.ApiKioskSearchByBarcodePostPath,
        KioskService.ApiKioskSearchByPinPostPath,
        KioskService.ApiKioskAddTransactionPostPath,
        KioskService.ApiKioskLogoutAlternatePostPath,
        KioskService.ApiKioskLogoutAccountPostPath,
        AgencyInquiryService.ApiAgencyinquirySignUpRequestPostPath,
        AgencyService.ApiAgencyCheckAgencyNameGetPath,
        AgencyService.ApiAgencyCheckBarcodeGetPath,
        AgencyService.ApiAgencyCheckPinGetPath
    ]
    
    // Do not attempt to refresh a user's credentials on these URLS
    // Dynamic URL example: "controller/endpoint/:id"
    AnonymousEndpoints_RelativeUrls: Array<string> = [
        AccountService.ApiAccountLoginPostPath,
        VersionService.ApiVersionGetPath,
        AccountService.ApiAccountVerifyAccountPostPath,
        AccountService.ApiAccountRefreshTokenGetPath,
        AccountService.ApiAccountInitRefreshPostPath,
        PasswordResetService.ApiPasswordresetSendResetEmailPostPath,
        PasswordResetService.ApiPasswordresetVerifyPasswordResetLinkPostPath,
        PasswordResetService.ApiPasswordresetResetPostPath,
        AgencyInquiryService.ApiAgencyinquirySignUpRequestPostPath
    ];

    constructor() {
        // Add addtional app config options here.
        this._config = {
            SnackBarDuartion: 5000
        };
    }

    // Usage example constructor injection: this.appConfig.setting['SnackBarDuartion']
    get setting(): { [key: string]: any } {
        return this._config;
    }

    get(key: any) {
        return this._config[key];
    }
}
